export const  WALLET_CONNECT_SUCCESS = 'WALLET_CONNECT_SUCCESS';
export const WALLET_CONNECT_FAILED = 'WALLET_CONNECT_FAILED';
export const WALLET_BALANCE_SUCCESS = 'WALLET_BALANCE_SUCCESS';
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const WALLET_LOGOUT_SUCCESS = 'WALLET_LOGOUT_SUCCESS';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
export const USER_PROFILE_IMAGE_UPDATE_SUCCESS = 'USER_PROFILE_IMAGE_UPDATE_SUCCESS';
export const USER_PROFILE_IMAGE_UPDATE_FAILED = 'USER_PROFILE_IMAGE_UPDATE_FAILED';